//Import React Library
import React, { useState } from 'react';

import { settings } from "constants/settings"

async function loadComponent() {
    return import('./Upload.' + settings.UI + '.js')
}

function UploadComponent(props) {

    const { children, data, recordType, recordPath, recordName, getProps } = props;

    const [component, setComponent] = useState(null)

    loadComponent().then(x => setComponent(x))

    if (!component) return null;
    return (
        <component.default data={data} recordType={recordType} recordPath={recordPath} recordName={recordName} getProps={getProps}>{children}</component.default>
    )
}

export default UploadComponent;